"use client";
export default function CertIndex() {
    return (
        <div className="container py-5 text-center col-12 col-xl-8 mx-auto p-6 bg-white rounded-4 p-4  shadow-sm">
            <h1>شهادات فيجماوية</h1>
            <p>في حال كنت تريد التحقق من صلاحية أو موثوقية شهادة،يمكنك التوجه لصفحة تدقيق الشهادات:</p>
            <div className="d-flex justify-content-center gap-3 mt-4">
                <a className="btn btn-primary" href="/cert/verify">التحقق من الشهادات</a>
                {/* <a className="btn btn-outline-primary" href="/services/cert/leaderboard">لوحة الشرف <i className="bi bi-trophy ms-1"></i></a> */}
            </div>
        </div>
    );
}